import { render, staticRenderFns } from "./postLocationList.vue?vue&type=template&id=e44d2068&"
import script from "./postLocationList.vue?vue&type=script&lang=js&"
export * from "./postLocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports